import {
  BrowseLearnedProgress,
  useBrowseDatasetStatsQueryOptions,
} from "@-/dev.improve.haniverse.routes.nav.app.browse._components.dataset-stats";
import { PrimaryControlsStripExpansionMutePushButton } from "@-/dev.improve.haniverse.routes.nav.app._components.primary-controls-strip.expansion.push-button.mute";
import { BrowseWordsDisplayPushButton } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.words._components.toolbar";
import { useStudiedGraphemesQueryOptions } from "@-/dev.improve.haniverse.lib.cards.user-card.grapheme.meaning.read";
import { useQuery } from "@-/com.npmjs.tanstack__react-query";
import { useMemo } from "react";
import { isNonEmpty } from "@-/com.npmjs.ts-array-length";
import arrayLength from "@-/com.npmjs.extra-array__length";
import { View } from "@-/com.npmjs.react-native";

/**
 * Header expansion strip for the Browse Words page: how many of the HSK-dataset words the user
 * has learned, plus Display (glyphs-vs-pinyin tiles; on HSK, whether one-glyph entries appear)
 * and Mute. Words have no study tracking of their own, so a word counts as learned when every
 * one of its characters is in the user's studied-grapheme set.
 */
export function BrowseWordsPrimaryControlsStripExpansionContent() {
  const { data: stats } = useQuery(useBrowseDatasetStatsQueryOptions());
  const { data: studiedGraphemes } = useQuery(useStudiedGraphemesQueryOptions());

  const { learnedCount, totalCount } = useMemo(() => {
    const words = stats?.words ?? [];
    const studied = studiedGraphemes ?? new Set<string>();
    let learned = 0;
    for (const { characters } of words) {
      if (isNonEmpty(characters) && characters.every((character) => studied.has(character))) {
        learned++;
      }
    }
    return { learnedCount: learned, totalCount: arrayLength(words) };
  }, [studiedGraphemes, stats]);

  return (
    <>
      <BrowseLearnedProgress learnedCount={learnedCount} noun="word" totalCount={totalCount} />
      <View className="flex-row items-center justify-center gap-2 py-1">
        <BrowseWordsDisplayPushButton />
        <PrimaryControlsStripExpansionMutePushButton />
      </View>
    </>
  );
}
